import * as React from 'react';

import type {SpamPreventionType} from 'nutshell-graphql-types';

import {useFormUpdate} from '../../helpers';

import {SpamPreventionCard} from './spam-prevention-card';
import {SpamPreventionForm} from './spam-prevention-form';
import {SpamPreventionSidebarForm} from './spam-prevention-sidebar-form';

type Props = {
    formId: string;
    spamPreventionType: SpamPreventionType;
};

export function SpamPreventionContainer(props: Props) {
    const [isShowingSpamPreventionTypeSidebar, setIsShowingSpamPreventionTypeSidebar] =
        React.useState<boolean>(false);

    const [saveFailedErrorMessage, setSaveFailedErrorMessage] = React.useState<
        string | null | undefined
    >(null);

    const updateForm = useFormUpdate();
    // @ts-expect-error
    const saveSpamPrevention = (formData): Promise<any> => {
        const saveData = {
            id: props.formId,
            spamPreventionType: formData.spamPreventionType,
        } as const;

        return updateForm({
            form: saveData,
        })
            .then(() => {
                setSaveFailedErrorMessage(null);
                setIsShowingSpamPreventionTypeSidebar(false);
            })
            .catch((error) => {
                setSaveFailedErrorMessage(error.message);
            });
    };

    return (
        <div className='full-height background-offwhite'>
            <SpamPreventionCard
                spamPreventionType={props.spamPreventionType}
                onClick={() => {
                    setIsShowingSpamPreventionTypeSidebar(true);
                }}
            />
            {isShowingSpamPreventionTypeSidebar ? (
                <SpamPreventionSidebarForm
                    // @ts-expect-error
                    title='Spam prevention'
                    onClose={() => {
                        setIsShowingSpamPreventionTypeSidebar(false);
                        setSaveFailedErrorMessage(null);
                    }}
                    // @ts-expect-error
                    onSubmit={(formData) => {
                        return saveSpamPrevention(formData);
                    }}
                    saveFailedErrorMessage={saveFailedErrorMessage}
                    initialValues={{
                        spamPreventionType: props.spamPreventionType,
                    }}
                >
                    <SpamPreventionForm />
                </SpamPreventionSidebarForm>
            ) : undefined}
        </div>
    );
}
